<lx-quote-cta-button *ngIf="hasProductInfo" [icon]="'info'" (buttonClicked)="infoButtonClicked.emit()"></lx-quote-cta-button>
<lx-quote-cta-button *ngIf="isProductEditable" [icon]="'edit'" (buttonClicked)="editButtonClicked.emit()"></lx-quote-cta-button>
<lx-quote-cta-button [icon]="'remove'" (buttonClicked)="removeButtonClicked.emit()"></lx-quote-cta-button>
